<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */
 -->

<template>
  <div class="expensa-audit-entity">
    <a v-if="reportId" :href="reportHref"> {{ entityType }} #{{ entityId }} </a>
    <span v-else-if="entityType">
      {{ entityType }}<template v-if="entityId"> #{{ entityId }}</template>
    </span>
    <span v-else>—</span>
  </div>
</template>

<script>
import {pageUrl} from '../util/api';

/** Entità di un evento di audit; per una nota (`report`) è un link. */
export default {
  name: 'ExpensaAuditEntity',
  props: {
    entityType: {type: String, default: null},
    entityId: {type: Number, default: null},
  },
  computed: {
    reportId() {
      return this.entityType === 'report' && this.entityId ? this.entityId : 0;
    },
    reportHref() {
      return pageUrl('viewReport', this.reportId);
    },
  },
};
</script>
